import { createUser } from '../../services/profile';
import { showSuccessMessage, showErrorMessage } from '../app';
import hideProfileModal from './hide-profile-modal';
import {
    PROFILE_START_LOADING_FORM,
    PROFILE_END_LOADING_FORM,
} from '.';

export const PROFILE_ADD_MEMBER = 'PROFILE_ADD_MEMBER';

function getError(error) {
    if (error.details) return error.details;
    if (error.code === 'permission-denied') return error.message;
    return 'Looks like there is a problem. Try again later.';
}

export default function addMember(data) {
    return async (dispatch) => {
        dispatch({
            type: PROFILE_START_LOADING_FORM,
        });
        try {
            const user = await createUser(data);
            dispatch(showSuccessMessage('The member has been successfully added.'));
            dispatch({
                type: PROFILE_END_LOADING_FORM,
            });
            dispatch(hideProfileModal());
            dispatch({
                type: PROFILE_ADD_MEMBER,
                member: user.data,
            });
        } catch (error) {
            dispatch(showErrorMessage(getError(error)));
            dispatch({
                type: PROFILE_END_LOADING_FORM,
            });
        }
    };
}
